// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"5c927e5b","117":"8cbb4303","525":"e1a7336f","642":"76c42009","675":"89cb9c53","884":"6358bad7"}[chunkId] + ".chunk.js";
};